var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_115176",
    "data-name": "Group 115176",
    transform: "translate(-326.301 -333.301)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3279",
    "data-name": "Ellipse 3279",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(327.301 334.301)",
    fill: "red",
    stroke: "#f7fbfc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "_65bfd1f026d9289cdaf7f35e6bff5197",
    "data-name": "65bfd1f026d9289cdaf7f35e6bff5197",
    d: "M5.227,4.117l2.78-2.78a.777.777,0,0,0,0-1.1L8,.228a.777.777,0,0,0-1.1,0l-2.78,2.78L1.338.228a.777.777,0,0,0-1.1,0L.228.239a.777.777,0,0,0,0,1.1l2.78,2.78L.228,6.9a.777.777,0,0,0,0,1.1l.011.011a.777.777,0,0,0,1.1,0l2.78-2.78L6.9,8.007a.777.777,0,0,0,1.1,0L8.007,8a.777.777,0,0,0,0-1.1Z",
    transform: "translate(334.684 341.684)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossSm);
export default __webpack_public_path__ + "static/media/cross-sm.e2f18a5f70af7ccc4f1cf9569572e7fd.svg";
export { ForwardRef as ReactComponent };